import {
  API_URL,
  store
} from '../index'
import axios from 'axios/index'

/* import error handler */
import ErrorHandler from '../ErrorHandler'

/* private TermsOfDeliverySettings Types */
import {
  Settings,
  _TermsOfDeliverySettings
} from '../namespace-helper'

import _ from 'lodash'

const selectedTermsOfDeliveryTemplate = {
  id: 0,
  name: '',
  description: ''
}

export default {
  namespaced: true,
  state: {
    termsOfDeliveries: [],
    allTermsOfDeliveries: [],
    selectedTermOfDelivery: _.cloneDeep(selectedTermsOfDeliveryTemplate),
    openNewDialog: false
  },
  mutations: {
    [_TermsOfDeliverySettings.mutations.setTermsOfDeliveries] (state, payload) {
      state.termsOfDeliveries = payload
    },
    [_TermsOfDeliverySettings.mutations.setAllTermsOfDeliveries] (state, payload) {
      state.allTermsOfDeliveries = payload
    },
    [_TermsOfDeliverySettings.mutations.setSelectedTermOfDelivery] (state, payload) {
      if (payload !== null) {
        state.selectedTermOfDelivery = payload
      } else {
        state.selectedTermOfDelivery = _.cloneDeep(selectedTermsOfDeliveryTemplate)
      }
    },
    [_TermsOfDeliverySettings.mutations.setOpenCloseNewDialogState] (state) {
      state.openNewDialog = !state.openNewDialog
    }
  },
  actions: {
    [_TermsOfDeliverySettings.actions.saveTermOfDelivery] (context, payload) {
      store.commit(Settings.mutations.setLoading, true)

      const data = JSON.stringify(payload)

      if (payload.id === 0) {
        var url = API_URL + '/api/v1/termOfDeliveries'

        axios.post(url, data, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          store.commit(Settings.mutations.setLoading, false)
          ErrorHandler.clear(store)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
        }).catch(e => console.error('#### ' + e))
      } else {
        url = API_URL + '/api/v1/termOfDeliveries/' + payload.id

        axios.put(url, data, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          store.commit(Settings.mutations.setLoading, false)
          ErrorHandler.clear(store)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
        }).catch(e => console.error('#### ' + e))
      }
    },
    [_TermsOfDeliverySettings.actions.loadTermsOfDeliveries] (context, payload) {
      console.log('loadTermsOfDeliveries: ' + JSON.stringify(payload))
      console.log('loadTermsOfDeliveries: ' + payload.sortBy + ' ' + payload.descending + ' ' + payload.page + ' ' + payload.limit)

      var url = API_URL + '/api/v1/termOfDeliveries?limit=' + payload.limit + '&page=' + payload.page + '&search=' + payload.search + '&searchFields=id:like;name:like;description:like&orderBy=' + payload.sortBy + '&sortedBy=' + payload.descending

      store.commit(Settings.mutations.setLoading, true)

      return axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        store.commit(Settings.mutations.setLoading, false)
        ErrorHandler.clear(store)
        context.commit(_TermsOfDeliverySettings.mutations.setTermsOfDeliveries, r.data.data)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },
    [_TermsOfDeliverySettings.actions.loadAllTermsOfDeliveries] (context, payload) {
      var url = API_URL + '/api/v1/termOfDeliveries'

      store.commit(Settings.mutations.setLoading, true)

      return axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        store.commit(Settings.mutations.setLoading, false)
        ErrorHandler.clear(store)
        context.commit(_TermsOfDeliverySettings.mutations.setAllTermsOfDeliveries, r.data.data)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },
    [_TermsOfDeliverySettings.actions.openCloseNewDialog] ({ commit }) {
      commit(_TermsOfDeliverySettings.mutations.setOpenCloseNewDialogState)
    },
    [_TermsOfDeliverySettings.actions.setSelectedTermOfDelivery] ({ commit }, payload) {
      commit(_TermsOfDeliverySettings.mutations.setSelectedTermOfDelivery, payload)
    },
    [_TermsOfDeliverySettings.actions.resetState] ({ commit }, payload) {
      commit(_TermsOfDeliverySettings.mutations.setTermsOfDeliveries, [])
      commit(_TermsOfDeliverySettings.mutations.setAllTermsOfDeliveries, [])
      commit(_TermsOfDeliverySettings.mutations.setSelectedTermOfDelivery, null)
    }
  },
  getters: {
    [_TermsOfDeliverySettings.getters.termsOfDeliveries] (state) {
      return state.termsOfDeliveries
    },
    [_TermsOfDeliverySettings.getters.getAllTermsOfDeliveries] (state) {
      return state.allTermsOfDeliveries
    },
    [_TermsOfDeliverySettings.getters.getOpenNewDialogState] (state) {
      return state.openNewDialog
    },
    [_TermsOfDeliverySettings.getters.getSelectedTermOfDelivery] (state) {
      return state.selectedTermOfDelivery
    }

  }
}



// WEBPACK FOOTER //
// ./src/store/Settings/termsOfDeliveries.js